module.exports = __webpack_public_path__ + "static/media/lupa-white.6a83777a.svg";